import React, { createContext, useState, useEffect } from "react";
import { toast, Toaster } from "sonner";
import { HeartSvg } from "../../public/svg/svg";

// Create the Favorites Context
export const FavoritesContext = createContext();

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState(() => {
    // Load favorites from localStorage when the provider is initialized
    const savedFavorites = localStorage.getItem("favorites");
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });

  // Save favorites to localStorage whenever the favorites list changes
  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

  // Toggle favorite function
  const handleFavoriteToggle = (estate) => {
    const isFavorite = favorites.some((fav) => fav.id === estate.id);
    
    setFavorites((prevFavorites) =>
      isFavorite
        ? prevFavorites.filter((fav) => fav.id !== estate.id) // Remove if already favorited
        : [...prevFavorites, estate] // Add if not in favorites
    );

    toast(
      <div className="flex gap-2 items-center">
                {isFavorite ?         <HeartSvg className="size-5 " />
 :         <HeartSvg className="size-5 fill-prime-600" />
}

        {isFavorite ? "Von der Merkliste gelöscht" : "Zur Merkliste hinzugefügt"}
      </div>
    );
  };

  return (
    <FavoritesContext.Provider value={{ favorites, handleFavoriteToggle }}>
      {children}
      <Toaster position="top-right" />
    </FavoritesContext.Provider>
  );
}
